import {
  COMPANYLIST} from 'actions/company';
import {reducerPackage} from "../../utils";
export const companyList = reducerPackage(COMPANYLIST);

